import styled from '@benzinga/themetron';
import { formatRisk } from './utils';

export const customColumnSettings: Record<string, any> = {
  affiliate_link: {
    render: (value: string) => {
      return (
        <DetailsButton href={value} target="_blank">
          Details & How to Invest
        </DetailsButton>
      );
    },
    width: 210,
  },
  yield_investments_annual_yield_pct: {
    defaultSortOrder: 'descend',
    width: 100,
  },
  yield_investments_investment_horizon: {
    width: 130,
  },
  yield_investments_issuer: {
    width: 250,
  },
  yield_investments_risk_level: {
    render: (value: number) => formatRisk(value),
    width: 110,
  },
};

export const customMobileColumnSettings: Record<string, any> = {
  display_name: {
    render: (_value: string, data: Record<string, string>) => {
      return (
        <div
          style={{
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 4,
            display: '-webkit-box',
            overflow: 'hidden',
            wordBreak: 'break-word',
          }}
        >
          <a
            dangerouslySetInnerHTML={{ __html: data.name }}
            href={data.link}
            rel="noreferrer"
            style={{ fontWeight: 'bold' }}
            target="_blank"
          />
          {data.issuer && (
            <div>
              <b>{data.issuer}</b>
            </div>
          )}
        </div>
      );
    },
    title: 'Investment & Issuer',
    width: '40%',
  },
  yield_investments_annual_yield_pct: {
    render: (_value: string, data: Record<string, any>) => {
      if (!data?.data) {
        return '-';
      }

      const { yield_investments_annual_yield_pct, yield_investments_risk_level } = data.data;

      const yieldValue = yield_investments_annual_yield_pct?.display_value;
      if (!yieldValue) {
        return '-';
      }

      return (
        <div className="more-info-text">
          <div style={{ fontWeight: 'bold' }}>{yieldValue}</div>
          {formatRisk(yield_investments_risk_level?.value)}
        </div>
      );
    },
    title: 'Yield & Risk',
    width: '30%',
  },
  yield_investments_investment_horizon: {
    width: '30%',
  },
};

const DetailsButton = styled.a`
  background-color: #e8e8e8;
  border-radius: 50px;
  color: #000;
  display: inline-block;
  padding: 5px 10px;
  font-weight: 800;
  white-space: nowrap;
`;
